import _ from 'lodash';

import {BubbleData} from './BubbleData';
import {ChartData} from './ChartData';
import {GridData} from './GridData';
import {PivotData} from './PivotData';
import {TreeMapData} from './TreeMapData';

const dataType = {
  bubble: (data) => new BubbleData(data),
  grid: (data) => new GridData(data),
  pivot: (data) => new PivotData(data),
  treemap: (data) => new TreeMapData(data),
  default: (data) => new ChartData(data)
};

export const DataFactory = (data) => {
  if (!data || !_.size(data.data) || data.type === 'none') {
    return {};
  }

  const {type} = data;
  const constructor = dataType[type] || dataType.default;
  return constructor(data);
};
